import { createNewSortInstance as createFastSort } from "fast-sort";

import i18n from "@/providers/i18n";

// ! in any comparison, NULL has to be transformed to UNDEFINED, see: https://github.com/snovakovic/fast-sort/issues/54#issuecomment-1072289388

const sortComparator = createFastSort({
  comparer: (a: string, b: string) => {
    const bothNumbers = !isNaN(Number(a)) && !isNaN(Number(b));
    if (bothNumbers) return Number(a) - Number(b);
    return new Intl.Collator(i18n.resolvedLanguage ?? undefined, {
      usage: "sort",
      sensitivity: "base",
      numeric: true,
    }).compare(a, b);
  },
});
export const sortArray = <T>(items: T[]) => {
  return sortComparator(items);
};

const sortComparatorInPlace = createFastSort({
  comparer: (a: string, b: string) => {
    const bothNumbers = !isNaN(Number(a)) && !isNaN(Number(b));
    if (bothNumbers) return Number(a) - Number(b);
    return new Intl.Collator(i18n.resolvedLanguage ?? undefined, {
      usage: "sort",
      sensitivity: "base",
      numeric: true,
    }).compare(a, b);
  },
  inPlaceSorting: true,
});
export const sortArrayInPlace = <T>(items: T[]) => {
  return sortComparatorInPlace(items);
};
